import type React from 'react';
import { FormattedMessage } from 'react-intl';

import type { Product } from '../api/product/types';
import { getGALabelsWrapped } from './gtm/gtmLabels';
import { gtmPromotionClick } from './gtm/gtmPromotions';
import { getCheckoutWindowProps } from './popupService';
import { getWindowScreen } from './screenWrapper';
import { createCheckoutUrl, extractUrlParameters } from './urlUtils';

const createRedirectToCheckout = (windowId: string, checkoutUrl: string) => (event: React.MouseEvent) => {
    event.preventDefault();
    const { windowName, sizeString } = getCheckoutWindowProps(getWindowScreen(), windowId);
    const internalCampaign = gtmPromotionClick();

    const url = new URL(checkoutUrl);
    url.searchParams.set('internalCampaign', internalCampaign);

    window.open(url.toString(), windowName, sizeString);
};

interface Props {
    product?: Product;
    className: string;
    disabled: boolean | undefined;
    noText: boolean;
    textOnly: boolean;
}

export function CheckoutButton({ className, noText, textOnly, disabled, product }: Props) {
    const { productId, assetIds, level, resourceIds } = extractUrlParameters(window.location.href);
    if (!productId) {
        return null;
    }

    const overwrittenLevel = level ?? product?.level;
    const windowId = productId + (overwrittenLevel ?? '');
    const checkoutUrl = createCheckoutUrl(productId, assetIds, overwrittenLevel, resourceIds);
    const redirectToCheckout = disabled ? undefined : createRedirectToCheckout(windowId, checkoutUrl);
    const gaLabels = disabled ? undefined : getGALabelsWrapped();

    return (
        <a className={className} href={checkoutUrl} onClick={redirectToCheckout} {...gaLabels?.click}>
            {!textOnly && <span className='uikit-icon icon-shopping-cart' />}
            {noText ? null : (
                <span>
                    <FormattedMessage id={'marketplace.buybutton.bookNow'} />
                </span>
            )}
        </a>
    );
}
